import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { SharingUnifiedInput, SharingUnifiedResponse } from '../models/sharings';

/**
 * <p>
 * API endpoints that cover all sharing unified related CRUD calls
 */

export const SharingUnifiedInputApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchSharingUnifiedBy: builder.query<PaginationResponse<SharingUnifiedResponse>, SharingUnifiedInput>({
      query: (input: SharingUnifiedInput) => ({
        url: encodeURI(
          `/indirect/sharing-unified/searchBy?period=${input.period}&destiniProjectSearchTerm=${input.destiniProjectSearchTerm}&originProjectSearchTerm=${input.originProjectSearchTerm}&personSearchTerm=${input.personSearchTerm}&page=${input.page}&size=${input.size}`,
        ),
      }),
      providesTags: ['SharingUnified'],
    }),
  }),
});

export const { useSearchSharingUnifiedByQuery } = SharingUnifiedInputApi;
